// =============================================================================
// twoFactor — czysta logika decyzji 2FA (AAL) + kill-switch env.
//
// Reguły AAL (Supabase MFA):
//   nextLevel === 'aal1'                      → user NIE MA 2FA (czynnik
//                                               niezweryfikowany się NIE liczy)
//   nextLevel === 'aal2' && current !== 'aal2' → ma 2FA, zalogowany samym hasłem
//   currentLevel === 'aal2'                   → pełne 2FA
//
// KILL-SWITCH: VITE_ENFORCE_2FA. Domyślnie WŁĄCZONE (enforce). Ustawienie
// wartości "false" w Coolify + redeploy wyłącza bramkę awaryjnie (gdyby
// zapętliła i zablokowała dostęp do panelu).
// =============================================================================

export interface AalLevels {
  currentLevel: string | null;
  nextLevel: string | null;
}

/** 'bypass' = kill-switch OFF, 'ok' = wpuść, 'setup' = wymuś /setup-2fa, 'code' = wymuś krok kodu */
export type TwoFactorDecision = "bypass" | "ok" | "setup" | "code";

export const ENFORCE_2FA: boolean =
  ((import.meta as any).env?.VITE_ENFORCE_2FA ?? "true") !== "false";

/**
 * Czysta decyzja na podstawie poziomów AAL. Testowalna bez Supabase.
 * Wywoływana TYLKO po udanym odczycie AAL — błąd odczytu obsługuje bramka (fail-closed).
 */
export function decide2fa(aal: AalLevels, enforce: boolean = ENFORCE_2FA): TwoFactorDecision {
  if (!enforce) return "bypass";
  if (aal.currentLevel === "aal2") return "ok";
  if (aal.nextLevel === "aal2") return "code";
  return "setup";
}
